module.exports = __webpack_public_path__ + "static/assets/9c029845bbb161b90781ac839ac533f6.gif";